const antlr4 = require("./antlr4/index");
const tempHCPParser = require("./HCPGrammarParser"); //HCP changes: Changed the variable to get the properties of HCPGrammarParser.
//Also in code the properties are accessed using 'tempHCPParser.HCPGrammarParser'.

function JavaScriptBaseParser(input) {
  antlr4.Parser.call(this, input);
  this.JavaScriptParser = input;
}

JavaScriptBaseParser.prototype = Object.create(antlr4.Parser.prototype);

JavaScriptBaseParser.prototype.p = function(str) {
  return this.prev(str);
};

JavaScriptBaseParser.prototype.prev = function(str) {
  const source = this._input.LT(-1).source[1].strdata;
  const start = this._input.LT(-1).start;
  const stop = this._input.LT(-1).stop;
  const prev = source.slice(start, stop + 1);
  return prev === str;
};

JavaScriptBaseParser.prototype.notLineTerminator = function() {
  return !this.here(tempHCPParser.HCPGrammarParser.LineTerminator);
};

JavaScriptBaseParser.prototype.notOpenBraceAndNotFunction = function() {
  const nextTokenType = this._input.LT(1).type;
  return (
    nextTokenType !== tempHCPParser.HCPGrammarParser.OpenBrace // &&
    //nextTokenType !== JavaScriptParser.Function
  );
};

JavaScriptBaseParser.prototype.closeBrace = function() {
  return this._input.LT(1).type === tempHCPParser.HCPGrammarParser.CloseBrace;
};

JavaScriptBaseParser.prototype.here = function(type) {
  const possibleIndexEosToken = this.getCurrentToken().tokenIndex - 1;
  const ahead = this._input.get(possibleIndexEosToken);
  return ahead.channel === antlr4.Lexer.HIDDEN && ahead.type === type;
};

JavaScriptBaseParser.prototype.lineTerminatorAhead = function() {
  let possibleIndexEosToken = this.getCurrentToken().tokenIndex - 1;
  let ahead = this._input.get(possibleIndexEosToken);
  if (ahead.channel !== antlr4.Lexer.HIDDEN) {
    return false;
  }

  if (ahead.type === tempHCPParser.HCPGrammarParser.LineTerminator) {
    return true;
  }

  if (ahead.type === tempHCPParser.HCPGrammarParser.WhiteSpaces) {
    possibleIndexEosToken = this.getCurrentToken().tokenIndex - 2; //HCP changes: Fixed the issue in getting Token Index from Current Token.
    ahead = this._input.get(possibleIndexEosToken);
  }

  const text = ahead.type;
  const type = ahead.type;

  return (
    (type === tempHCPParser.HCPGrammarParser.MultiLineComment &&
      (text.includes("\r") || text.includes("\n"))) ||
    type === tempHCPParser.HCPGrammarParser.LineTerminator
  );
};

module.exports.JavaScriptBaseParser = JavaScriptBaseParser;
